module.exports = __webpack_public_path__ + "static/media/知识运营-插画2x.314fd198.png";